import React from 'react';
import { Container } from './styles';
import { useMfeOptions } from 'src/contexts/MfeOptionsContext';
import { InitializationMethod } from 'src/types/mfeProps';
import { OnboardingStep } from 'src/types/onboardingStep';

export interface ConditionalModalProps {
  onboardingStep: OnboardingStep;
  children?: React.ReactNode;
}

export const ConditionalModalContainer: React.FC<ConditionalModalProps> = ({
  onboardingStep,
  children
}) => {
  const {
    options: { initializationMethod }
  } = useMfeOptions();

  if (
    initializationMethod === InitializationMethod.Modal &&
    onboardingStep !== OnboardingStep.SELECT_TENANT
  )
    return <Container>{children}</Container>;

  return <>{children}</>;
};
